// Hook to post the /application/merge response

/*  Shared  */
import { Notify } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import { useCallback, useState } from 'react';

export const usePostApplicationMerge = (t) => {
    const [saving, setSaving] = useState(false);

    const postApplicationMerge = useCallback(
        async ({ fromId, toId }) => {
            try {
                setSaving(true);
                const params = { fromId, toId };
                await axios.post('/application/merge', params);
                Notify.success(t('GlobalAdmin.Applications.mergeSubmitted'));
                setSaving(false);
                return true; // success = true
            } catch (err) {
                Notify.error(t('GlobalAdmin.Applications.mergeError'));
                debug.e('Unable to merge apps.', err);
                setSaving(false);
                return false; // success = false
            }
        },
        [t]
    );

    return { postApplicationMerge, saving };
};
